/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './app.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/router';
import * as i3 from '../../app/app.component';
const styles_AppComponent:any[] = [i0.styles];
export const RenderType_AppComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,styles:styles_AppComponent,
    data:{}});
export function View_AppComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(-1,(null as any),['\n		'])),(_l()(),i1.ɵeld(2,16777216,(null as any),
      (null as any),1,'router-outlet',([] as any[]),(null as any),(null as any),(null as any),
      (null as any),(null as any))),i1.ɵdid(3,212992,(null as any),0,i2.RouterOutlet,
      [i2.ChildrenOutletContexts,i1.ViewContainerRef,i1.ComponentFactoryResolver,[8,
          (null as any)],i1.ChangeDetectorRef],(null as any),(null as any)),(_l()(),
      i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],
      (_ck,_v) => {
        _ck(_v,3,0);
      },(null as any));
}
export function View_AppComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app',([] as any[]),
      (null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
      i1.ɵdid(1,49152,(null as any),0,i3.AppComponent,([] as any[]),(null as any),
          (null as any))],(null as any),(null as any));
}
export const AppComponentNgFactory:i1.ComponentFactory<i3.AppComponent> = i1.ɵccf('#app',
    i3.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL0NocmlzL0RvY3VtZW50cy9XZWJEZXYvRGV2R2VuQW5nL3NyYy9hcHAvYXBwLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9DaHJpcy9Eb2N1bWVudHMvV2ViRGV2L0RldkdlbkFuZy9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMiLCJuZzovLy9Vc2Vycy9DaHJpcy9Eb2N1bWVudHMvV2ViRGV2L0RldkdlbkFuZy9zcmMvYXBwL2FwcC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL1VzZXJzL0NocmlzL0RvY3VtZW50cy9XZWJEZXYvRGV2R2VuQW5nL3NyYy9hcHAvYXBwLmNvbXBvbmVudC50cy5BcHBDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2PlxuXHRcdDxyb3V0ZXItb3V0bGV0Pjwvcm91dGVyLW91dGxldD5cbjwvZGl2PlxuIiwiPGFwcD48L2FwcD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUEsd0VBQUs7YUFBQSw2QkFDSDtNQUFBO01BQUEscUNBQUE7TUFBQTtVQUFBLGtFQUErQjthQUFBLDJCQUMzQjs7UUFESjs7OztvQkNERjtNQUFBO2FBQUE7VUFBQTs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/app.component.ngfactory.ts